import axios from "axios";

axios.defaults.baseURL =
  "https://us-central1-fbadmanager-2f3a1.cloudfunctions.net/api";
// axios.defaults.baseURL =
//   "http://localhost:5001/fbadmanager-2f3a1/us-central1/api";
export default axios;
